import React from 'react';
import MatClntCoreTransactionList from './MatClntCoreTransactionList';

export default function MatClntIncomingList() {
  return (
    <MatClntCoreTransactionList
      title="Client Material - Incoming Transactions"
      opTypes={["incoming"]}
    />
  );
}
